import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import useBreakpoints from '#client/hooks/useBreakpoints';
import { BannerWrapperStyled } from '#client/pages/SharedStyles';

import { ImageWrapper, Banner, DividerStyled } from './WirePaymentWarning.styles';

const warningIcon = (
  <SharedAsset
    alt=""
    src="/s2/vector/caution-warning-illustration-icon.svg"
  />
);

export default function WirePaymentWaring() {
  const {
    sizes: { isDesktop }
  } = useBreakpoints();

  return (
    <BannerWrapperStyled>
      <Banner
        alignItems="center"
        direction="row"
      >
        {isDesktop ? (
          <ImageWrapper>{warningIcon}</ImageWrapper>
        ) : (
          <DividerStyled orientation="vertical" />
        )}
        <Stack gap="4px">
          <Text
            color="primary"
            size="lg"
            weight="medium"
          >
            Avoid fraud
          </Text>
          <Text
            color="primary"
            size="md"
          >
            Always call your recipient on a known number to confirm their account details. It’s very
            unlikely to get your money back once you’ve submitted your wire request even if you were
            scammed.
          </Text>
        </Stack>
      </Banner>
    </BannerWrapperStyled>
  );
}
